// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"iT4IiY5Kf7AOmMQ5FYIbS","tooltipcontent":"_2Fw9cGtMMqj0PruGGWeLnO"};